import { cn } from 'components/UI/cn'
import { PiUser, PiUsersThree } from 'react-icons/pi'

export type InboxTab = 'my_emails' | 'all_team_emails'

interface InboxTabsProps {
  selectedTab: InboxTab
  onTabChange: (tab: InboxTab) => void
  /** Optional per-tab email counts, rendered as a DS2026 pill next to the
   *  label (green when active, gray when inactive). Omit a tab's entry to
   *  hide its pill. */
  counts?: Partial<Record<InboxTab, number>>
}

const tabs: { key: InboxTab; label: string; icon: React.ReactNode }[] = [
  {
    key: 'all_team_emails',
    label: 'All Team Emails',
    icon: <PiUsersThree className="size-[18px]" />,
  },
  {
    key: 'my_emails',
    label: 'My Emails',
    icon: <PiUser className="size-[18px]" />,
  },
]

/** Tab bar toggling between "All Team Emails" and "My Emails" views. */
export function InboxTabs({
  selectedTab,
  onTabChange,
  counts,
}: InboxTabsProps) {
  return (
    <div className="flex border-b border-neutral-200 bg-surface">
      {tabs.map(({ key, label, icon }) => {
        const isActive = selectedTab === key
        const count = counts?.[key]
        return (
          <button
            key={key}
            type="button"
            onClick={() => onTabChange(key)}
            className={cn(
              'flex items-center gap-2 px-4 h-[54px] text-sm tracking-[-0.14px] select-none transition-colors relative -mb-px border-b-2',
              isActive
                ? 'font-semibold text-neutral-800 border-brand-active'
                : 'font-medium text-neutral-500 border-transparent hover:text-neutral-800'
            )}
          >
            {icon}
            {label}
            {count !== undefined && (
              <span
                className={cn(
                  'inline-flex items-center justify-center min-w-[20px] px-1.5 py-0.5 rounded-full text-xs font-semibold tabular-nums',
                  isActive
                    ? 'bg-brand-sage-100 text-brand-active'
                    : 'bg-neutral-100 text-neutral-600'
                )}
              >
                {count.toLocaleString()}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
